// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/svg/Icon_search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-multiple-header[data-v-5dad1ea6] {
  width: auto;
  height: 35px;
  transition: all 0.2s ease-in-out;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  position: relative;
  cursor: pointer;
  gap: 5px;
}
.drop-multiple-header:hover .drop-title[data-v-5dad1ea6] {
  background-color: #ededed;
}
.drop-multiple-header.rotate .select-input[data-v-5dad1ea6] {
  order: 3;
}
.drop-multiple-header.rotate .drop-list[data-v-5dad1ea6] {
  order: 2;
}
.drop-multiple-header.rotate .drop-actions[data-v-5dad1ea6] {
  order: 1;
}
.drop-multiple-header.rotate .drop-options[data-v-5dad1ea6] {
  flex-direction: column-reverse;
  margin-bottom: 3px;
}
.drop-multiple-header.active[data-v-5dad1ea6] {
  box-shadow: 0 1.5px 5.8px 0 rgba(0, 0, 0, 0.17);
  z-index: 10000;
}
.drop-multiple-header.active.rotate .drop-title[data-v-5dad1ea6] {
  border-radius: 0 0 5px 5px;
}
.drop-multiple-header.active.rotate .drop-options[data-v-5dad1ea6] {
  border-radius: 5px 5px 0 0;
}
.drop-multiple-header.active .drop-title[data-v-5dad1ea6] {
  background-color: #ededed;
  border-color: white;
}
.drop-multiple-header .drop-title[data-v-5dad1ea6] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 12px;
  border-radius: 5px;
  border: solid 2px #dbdbdb;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  height: 100%;
}
.drop-multiple-header .drop-title svg[data-v-5dad1ea6] {
  width: 20px;
}
.drop-multiple-header .drop-title span[data-v-5dad1ea6] {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.drop-multiple-header .drop-options[data-v-5dad1ea6] {
  display: flex;
  flex-direction: column;
  z-index: 10000;
  position: absolute;
  left: 0;
  max-height: max-content;
  background: #fff;
  box-shadow: 0 1.5px 5.9px 0.7px rgba(0, 0, 0, 0.17);
  margin-top: 3px;
  border-radius: 5px;
  overflow-y: hidden;
}
.drop-multiple-header .drop-options .drop-list[data-v-5dad1ea6] {
  margin-top: 1px;
  min-height: 35px;
}
.drop-multiple-header .drop-options .drop-list .no-results[data-v-5dad1ea6] {
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  font-size: 14px;
  color: #5f5f5f;
  font-weight: normal;
}
.drop-multiple-header .drop-item[data-v-5dad1ea6] {
  height: 35px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 14px;
  color: #5f5f5f;
  font-weight: normal;
  overflow-x: hidden;
  cursor: pointer;
  gap: 5px;
  line-height: 1.5;
}
.drop-multiple-header .drop-item.active[data-v-5dad1ea6] {
  font-weight: 600;
}
.drop-multiple-header .drop-item span[data-v-5dad1ea6] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
}
.drop-multiple-header .drop-item[data-v-5dad1ea6]:hover {
  background-color: #f4f4f4;
}
.drop-multiple-header .select-input[data-v-5dad1ea6] {
  border: 2px solid #ededed;
  height: 35px;
  margin: 2px 2px;
  border-radius: 5px;
}
.drop-multiple-header .select-input.custom[data-v-5dad1ea6] {
  border-radius: 5px !important;
  border-top: 2px solid #ededed !important;
  margin: 2px 2px !important;
  height: 38px;
}
.drop-multiple-header .select-input[data-v-5dad1ea6]:nth-child(2) {
  border-top: unset;
  margin: -2px 2px;
  border-radius: 0 0 5px 5px;
}
.drop-multiple-header .select-input .drop-item[data-v-5dad1ea6] {
  padding: 0 5.5px;
}
.drop-multiple-header input[data-v-5dad1ea6] {
  width: 100%;
  outline: none;
  border: 4px solid transparent;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat scroll 5px 3px;
  padding-left: 30px;
}
.prop-name .color-dot[data-v-5dad1ea6] {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.prop-name.active[data-v-5dad1ea6] {
  font-weight: 600;
}
.select-svg[data-v-5dad1ea6] {
  display: flex;
  align-items: center;
}
.drop-actions[data-v-5dad1ea6] {
  box-shadow: 0 -2px 0 #ededed;
}
.drop-buttons[data-v-5dad1ea6] {
  display: flex;
  justify-content: flex-end;
  padding: 8.5px 15px;
  gap: 15px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.5px;
  color: #8d8d8d;
}
.drop-buttons button[data-v-5dad1ea6]:nth-child(2) {
  font-weight: 600;
  color: #4195ff;
}
.group-category[data-v-5dad1ea6]:not(:first-child) {
  box-shadow: 0 -2px 0 0 #ededed;
}
.group-category .category-title[data-v-5dad1ea6] {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  color: #5f5f5f;
  font-weight: 600;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: 600;
  border-top: 2px solid transparent;
  border-bottom: 2px solid #ededed;
}
.group-category .category-title[data-v-5dad1ea6]:hover {
  background-color: #ededed;
}
.group-category .category-title .item-count[data-v-5dad1ea6] {
  color: #8d8d8d;
  font-weight: 400;
}
.group-category .category-items[data-v-5dad1ea6] {
  overflow-y: auto;
  max-height: 165px;
}
.selected-count[data-v-5dad1ea6] {
  background-color: #4195FF;
  color: #fff;
  font-size: 12px;
  padding: 0 5px;
  height: 14px;
  line-height: 1.3;
  display: flex;
  align-self: center;
  border-radius: 4px;
  margin-right: 3px;
}
.v-enter-active[data-v-5dad1ea6],
.v-leave-active[data-v-5dad1ea6] {
  transition: opacity 0.2s ease-in-out;
}
.v-enter-from[data-v-5dad1ea6],
.v-leave-to[data-v-5dad1ea6] {
  opacity: 0;
}
[data-v-5dad1ea6] .drop-multiple-header .drop-title svg {
  transition: transform 0.2s ease-in-out;
}
[data-v-5dad1ea6] .drop-multiple-header.active .drop-title svg.drop-icon {
  transform: rotate(180deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
